import { render } from "./TimePhase.vue?vue&type=template&id=46e3bfc7"
import script from "./TimePhase.vue?vue&type=script&lang=js"
export * from "./TimePhase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__